import { isOfType } from '../guards'

export const domainTypesArr = ['TWT', 'Z', 'ANY'] as const

export type DomainType = (typeof domainTypesArr)[number]

export const isDomainType = isOfType(domainTypesArr)
